import React, { useEffect, useState } from "react";
import { getAllActive } from "../../../Infrastructure/Services/DataService";
import { getWithExpiry } from "../../../Domain/Helpers/LocalStorageHelper";
import { formatArrayForSelectInput } from "../../../Domain/Helpers/SelectInputHelper";
import { inputType } from "../../../Domain/Constants/InputType";
import GenericInsertUpdatePage from "../../../Domain/Components/Functional/GenericInsertPage/GenericInsertPage";
import { toast } from "react-toastify";

function CampaignOperatorGameUpdatePage(props) {
    const [campaign, setCampaign] = useState(null);
    const [operator, setOperator] = useState(null);
    const [provider, setProavider] = useState(null);
    const [inputs, setInputs] = useState([]);

    useEffect(() => {
        const token = getWithExpiry("token");

        if (token === null) {
            props.setLoggedIn(false);
            return;
        }

        getAllActive("operator/read", token).then((data) => {
            if (data === null) {
                toast.error("Failed to load the available Operators");
            } else {
                setOperator(data);
            }
        }).catch((ex) => {
            toast.error(ex);
        });

        getAllActive("campaign/read", token).then((data) => {
            if (data === null) {
                toast.error("Failed to load the available campaigns");
            } else {
                setCampaign(data);
            }
        }).catch((ex) => {
            toast.error(ex);
        });

        getAllActive("provider/read", token).then((data) => {
            if (data === null) {
                toast.error("Failed to load the available providers");
            } else {
                setProavider(data);
            }
        }).catch((ex) => {
            toast.error(ex);
        });
    }, []);

    useEffect(() => {
        if (campaign && operator && provider) {
            setInputs([
                {
                    inputType: inputType.SELECT,
                    labelText: "Campaign",
                    required: true,
                    inputId: "campaignId",
                    validationFunction: () => {return null},
                    selectOptions: formatArrayForSelectInput(campaign, "name")
                },
                {
                    inputType: inputType.SELECT,
                    labelText: "Operator",
                    required: true,
                    inputId: "operatorId",
                    validationFunction: () => {return null},
                    selectOptions: formatArrayForSelectInput(operator, "company_name")
                },
                {
                    inputType: inputType.SELECT,
                    labelText: "Provider",
                    required: true,
                    inputId: "providerId",
                    validationFunction: () => {return null},
                    selectOptions: formatArrayForSelectInput(provider, "name")
                }
            ])
        }
    }, [operator, campaign, provider])

    return (
        <GenericInsertUpdatePage inputs={inputs}
            setLoggedIn={props.setLoggedIn}
            endpoint={"campaign-operator-gameconfig/bulk-insert-provider-games"}
            pageTitle={"Update Campaign Game Config"}
            isUpdate={false}
            getEndpoint={"campaign-operator-gameconfig/read"}
            entityName={"Campaign Game Config"} />
    )
}

export default CampaignOperatorGameUpdatePage;